import React from 'react';

export const LinkedIn = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 37 35" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.256 12.112V34.4H.48V12.112h7.776zm19.568-.016c5.072 0 8.592 3.76 8.592 10.896V34.4h-8.592V22.8a3.424 3.424 0 00-3.408-3.44H24.4v.016a3.424 3.424 0 00-3.419 3.236l-.005.188v11.6H12.8V12.112h8.176v2.544a10.813 10.813 0 016.848-2.56zM4.4.4a4 4 0 013.968 4H8.4a4 4 0 11-8 0 4 4 0 014-4z"
      fillRule="evenodd"
    />
  </svg>
);

export default LinkedIn;
